import React from "react";
// import "../CreateNewProgram/CreateNewProgramStyle.css";
import close from "../../../assets/svg/close.svg";
import Button from "../../Button/Button";
import InputField from "../../InputField/InputField";
import moment from "moment/moment";

import { useDispatch } from "react-redux";
import { useState } from "react";
import { updateBlogDate } from "../../../redux/blogs/blogSlice";
// import {
//   extendInvitation,
// } from "../../../redux/applicant/applicantSlice";

const UpdateCreatedOnPopup = ({
  showActive,
  onCancel,
  isPopupFetching,
  blogId,
}) => {


  const dispatch = useDispatch();
 

  const [Date, setDate] = useState("");

  const [errors, setErrors] = useState("");

  const onChangeFormData = (event) => {
    const { name, value } = event.target;
    setDate(value);
    setErrors("");
  };
  const extendInvite = () => {
    let newErrors =  ""

    if (!Date) {
      newErrors = "Field required.";
    } 
    
    if (newErrors) {
      setErrors(newErrors);
      return;
    }
    dispatch(updateBlogDate({id : blogId, createdAt : Date}))
  };


  console.log(blogId , "blogId" , Date);


  return (
    <div className={`popupWrapper ${showActive && "active"}`}>
      <div className="popupContainer paymentPopup scorePopup" style={{height : "36vh"}}>
        <div className="popupHeader">
          <h4 className="popupHeading" style={{
            "display":"flex",
            "gap":'10px'
          }}>{`Update Date`} </h4>
          <span
            className="close"
            onClick={() => {
              onCancel(null, false);
                }}
          >
            <img src={close} alt="" />
          </span>
        </div>
        <div className="popupBody">
          <div className={`formEvent flexbox`}>
              <div className="flexbox singleFormOptions" >
                <InputField
                  type={"date"}
                  checkBoxWrap={"formdropdowns"}
                  notImp={false}
                  labelName={"Select Date"}
                  name="updateDate"
                  isError={errors ? true : false}
                  erroMessage={errors}
                  onChange={onChangeFormData}
                  value={Date}
                  disabled={isPopupFetching}
                />
              </div>
             
          </div>
        </div>
        <div className="popupFooter">
          <div className="buttonWrapper">
            <Button
              className={`GreenFillButton`}
              name={"Extend Invite"}
              onClick={extendInvite}
              isWaiting={isPopupFetching}
              disabled={isPopupFetching}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCreatedOnPopup;
